import React, {Component} from 'react';
import TsLogoSmall from '../images/tsLogoSmall.png';
import {
	Dropdown,
	DropdownMenu,
	DropdownItem,
	DropdownToggle,
	Nav,
	Navbar,
	NavbarBrand,
	NavItem
} from 'reactstrap';

class Header extends Component {
	render() {
		let leftNavs = [];
		let rightNavs = [];
		let targetURL = `${this.props.reportPrefix}/#/from-atlas/`;

		if (this.props.section === 'SPLASH' || this.props.section === '') {
			return (
				<Navbar className="header">
					<NavbarBrand>
						<img
							className="headerLogo"
							src={TsLogoSmall}
							alt="TouchSource Logo"
						/>
					</NavbarBrand>
					<NavbarBrand className="true-center" style={{color: 'white'}}>
						Welcome!
					</NavbarBrand>
					<Nav className="top-nav">
						<Dropdown
							nav
							isOpen={this.props.headerDropDown}
							toggle={this.props.toggleHeaderDropDown}
						>
							<DropdownToggle nav caret>
								Project Mgmt
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem onClick={this.props.goToCreateNew}>
								  New Project
								</DropdownItem>
								<DropdownItem
									onClick={() => {
										this.props.goToAdmin(() => {});
									}}
								>
								  Display Admin Menu
								</DropdownItem>
								<DropdownItem onClick={this.props.goToUserAdmin}>
								  User Admin Menu
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<div key={4} className="seperator" />
						<NavItem key={5} onClick={() => {
							window.open(targetURL, '_blank');
						}}>
						  Reports
						</NavItem>
					</Nav>
				</Navbar>
			);
		}

		let showContent = this.props.routeData && this.props.routeData.customer;

		if (showContent) {
			leftNavs.push(
				<NavItem style={{color: 'white'}} key={0}>{`P${
					this.props.routeData.customer.property_number
				}`}</NavItem>
			);
			leftNavs.push(<div key={1} className="seperator" />);
			leftNavs.push(
				<NavItem style={{color: 'white'}} key={2}>{`${
					this.props.routeData.customer.property_name
				}  `}</NavItem>
			);
		} else {
			leftNavs.push(
				<NavItem style={{color: 'white'}} key={0}>
          TouchSource Internal Dashboard
				</NavItem>
			);
		}

		rightNavs.push(
			<Dropdown
				nav
				key={3}
				isOpen={this.props.headerDropDown}
				toggle={this.props.toggleHeaderDropDown}
			>
				<DropdownToggle nav caret>
          Projects
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem onClick={this.props.goBackToSplash}>
						Search Projects
					</DropdownItem>
					<DropdownItem onClick={this.props.goToCreateNew}>
						New Project
					</DropdownItem>
					<DropdownItem onClick={this.props.goToDelete}>
						Delete Project
					</DropdownItem>
					<DropdownItem
						onClick={() => {
							this.props.goToAdmin(() => {});
						}}
					>

					  Display Admin Menu
					</DropdownItem>
					<DropdownItem onClick={this.props.goToUserAdmin}>
					  User Admin Menu
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>,
			<div key={4} className="seperator" />,
			<NavItem key={5} onClick={() => {
				window.open(targetURL, '_blank');
			}}>
				Reports
			</NavItem>,
			<div key={6} className="seperator" />,
			<NavItem key={7} onClick={this.props.goToPortal} >
        Content
			</NavItem>
		);

		return (
			<div>
				<Navbar className="header">
					<NavbarBrand className="homeHeader mr-auto">
						<img
							className="headerLogo"
							src={TsLogoSmall}
							alt="TouchSource Logo"
							onClick={this.props.goBackToSplash}
						/>
					</NavbarBrand>
					<Nav className="bigger-font">{leftNavs}</Nav>
					<Nav className="top-nav">{rightNavs}</Nav>
				</Navbar>
			</div>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js